import React, {Component} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import IconFeedback from '@material-ui/icons/Comment';
import DialogContentText from '@material-ui/core/DialogContentText';
import {TextField, Slide, withStyles} from '@material-ui/core';
import {State, Props} from './type';
import {styles} from './styles';

function Transition(props: any) {
    return <Slide direction="up" {...props} />;
}

export class Modal extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            message: '',
            clickSend: false
        };
    }

    handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({message: e.target.value});
    }

    closeModal = () => {
        this.props.handleClose();
        this.clearMessage();
    }

    sendMessage = () => {
        this.setState({clickSend: true});
        if (this.isEmptyMessage()) {
            return;
        }
        this.props.rejectNotification(this.state.message);
        this.clearMessage();
    }

    clearMessage = () => {
        this.setState({message: '', clickSend: false});
    }

    isEmptyMessage = () => {
        return this.state.message.trim() === '';
    }

    render() {
        const {classes} = this.props;
        return (
            <Dialog
                open={this.props.isOpen}
                TransitionComponent={Transition}
                keepMounted={true}
                fullWidth={true}
                classes={{paper: classes.modal}}
                onClose={this.closeModal}>
                <DialogContent classes={{root: classes.content}}>
                    <DialogContentText classes={{root: classes.contentText}}>
                        <IconFeedback classes={{root: classes.icon}}/>
                        Are you sure you want to reject this feedback?
                    </DialogContentText>
                </DialogContent>
                <TextField
                    label="Point the reasons of reject"
                    multiline={true}
                    error={this.isEmptyMessage() && this.state.clickSend}
                    rows="7"
                    value={this.state.message}
                    onChange={this.handleChange}
                    variant="outlined"
                />
                <DialogActions>
                    <Button onClick={this.closeModal} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={this.sendMessage} color="primary">
                        Send
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(styles)(Modal);
